import CrudSection from "../components/CrudSection";
import FeatureDashboard from "../../../components/base/FeatureDashboard";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import WorkflowsLive from "./WorkflowsLive";
import type { CrudColumn } from "../types";

// ===========================================================================
// Automatizaciones — workflows y ejecuciones (mock data, demo).
// ===========================================================================

export function AutomatizacionesDashboard() {
  return (
    <FeatureDashboard noticeKey="crm.mockNotice"
      title="Automatizaciones"
      subtitle="Flujos de trabajo basados en disparadores y acciones"
      icon="ri-flow-chart"
      stats={[
        { label: "Workflows activos", value: "6", icon: "ri-git-branch-line" },
        { label: "Ejecuciones (mes)", value: "1,820", icon: "ri-play-circle-line" },
        { label: "Tasa de éxito", value: "98.4%", icon: "ri-check-line", change: "+0.3%", positive: true },
        { label: "Con error", value: "29", icon: "ri-error-warning-line", change: "Revisar", positive: false },
      ]}
      recent={{
        title: "Disparadores frecuentes",
        items: [
          { primary: "Lead creado desde landing", secondary: "→ asignar dueño + tarea + correo", badge: "Activo", tone: "ok" },
          { primary: "Negocio movido a Ganado", secondary: "→ crear factura + notificar", badge: "Activo", tone: "ok" },
          { primary: "Ticket urgente creado", secondary: "→ escalar a soporte L2", badge: "Activo", tone: "info" },
        ],
      }}
    />
  );
}

// --- Workflows (LIVE) ------------------------------------------------------
// Real CRM automations. The wired automation is: lead.created → AI call.
// See sections/WorkflowsLive.tsx.
export const WorkflowsSection = WorkflowsLive;

// --- Ejecuciones (log) -----------------------------------------------------
interface Ejecucion extends Record<string, unknown> {
  id: string; fecha: string; workflow: string; entidad: string; resultado: string;
}
const ejecucionColumns: CrudColumn<Ejecucion>[] = [
  { key: "fecha", label: "Fecha y hora" },
  { key: "workflow", label: "Workflow" },
  { key: "entidad", label: "Entidad" },
  { key: "resultado", label: "Resultado", align: "center", render: (r) => <StatusTextBadge value={r.resultado} /> },
];
const ejecucionSeed: Ejecucion[] = [
  { id: "ej1", fecha: "2026-06-09 10:32", workflow: "Bienvenida a lead", entidad: "Acme Logistics", resultado: "Completado" },
  { id: "ej2", fecha: "2026-06-09 09:01", workflow: "Negocio ganado → factura", entidad: "SaaS Upgrade", resultado: "Completado" },
  { id: "ej3", fecha: "2026-06-08 22:14", workflow: "Bienvenida a lead", entidad: "Lead #4821", resultado: "Rechazado" },
];
export const EjecucionesSection = () => (
  <CrudSection<Ejecucion> title="Ejecuciones" subtitle="Historial de automatizaciones"
    icon="ri-play-circle-line" columns={ejecucionColumns} fields={[]} seed={ejecucionSeed} searchKey="workflow" readOnly />
);
